import { Injectable, Renderer2 } from '@angular/core';
import { ComponentDecorator, ContentSlotComponentData } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class GGComponentDecorator extends ComponentDecorator {
  decorate(element: Element, renderer: Renderer2, component: ContentSlotComponentData): void {
    if (component) {
      (element as any).customData = component.properties;
    }
  }
}
